import React from 'react';
import { chooseYourOwnPriceConfiguration, fixedPriceConfiguration } from "./LineItemUnitPriceTypes"
import { CurrencyAmount, FormatCurrencyValue, formatCurrencyValue } from "../../../utils/currency"
import GACurrencyInput, { GACurrencyInputOnChangeValues } from '../../inputs/GACurrencyInput';

/**
 * Implmentation of the Choose your own unit price type, where the user may input their preferred price.
 */

/**Component interface:
 * lineItemName: Name of line item
 * uniPriceConfiguration: Configuration of the unit price.
 * onPriceChange: Callback when the price is adjusted. Used for total price calculations and sending to payment processing.
 * onPriceValidityChange: Callback when the price validity is adjusted. Used for determining whether line item is valid for payment submission.
 *      errorMsg is for the message to be displayed below the checkout button.
 * onPriceDisplayChange: Callback when the value to be displayed in the unit price display changes.
 */
interface FixedUnitPriceDisplayProps {
    lineItemId: number,
    unitPriceConfiguration: fixedPriceConfiguration,
    quantity: number,
    onPriceChange: (lineItemId : number, newAmount:CurrencyAmount) => void,
    onPriceValidityChange: (lineItemId: number, isValid: boolean, errormMsg?: string) => void,
    onPriceDisplayChange: (newValue: string) => void,
}

const FixedUnitPriceDisplay = (props: FixedUnitPriceDisplayProps) =>
{
    React.useEffect(() => 
    {
        const unitPrice = props.unitPriceConfiguration.price.value.float;
        const totalPriceVal = formatCurrencyValue(unitPrice ? unitPrice * props. quantity : 0, props.unitPriceConfiguration.price.currency.formatting);
        const totalPrice = {...props.unitPriceConfiguration.price, value: totalPriceVal};

        props.onPriceChange(props.lineItemId, totalPrice);
        props.onPriceDisplayChange(totalPrice.value.formatted ?? "$0.00");
        props.onPriceValidityChange(props.lineItemId, true, "");
    },[props.quantity])
    
    return(<div></div>)
}

export default FixedUnitPriceDisplay;